module.exports = __webpack_public_path__ + "media/images/team/SEvmorfia-60adadd258619f8ea8c1b6a1d8c25c15.jpg";